<dashboard-page *ngIf="dashboardOptions$ | async as dashboardOptions" [options]="dashboardOptions"></dashboard-page>
